<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import DataUtil from '@/views/mis/util/data'
    
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    
    let type = {0:"禁用",1:"启用"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$router.push({path:"/mis/emailTemplate/edit",query:{id:row.id,label:"MIS"}});
                } else if (clickName == "view"){
                    this.$router.push({path:"/mis/emailTemplate/edit",query:{id:row.id,view:1,label:"MIS"}});
                } else if (clickName == "delete"){
                    this.dataChanage(URL.email.deleteTemplateId,{id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "changeEnabled"){
                    this.dataChanage(URL.email.changeEnabled,{enabled:row.enabled,id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.query') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t('mis.bt.add') == clickName){
                    //window.location="/mis/emailTemplate/edit?label=MIS";
                    //window.location="/mis/starlevel/list?label=MIS";
                    this.$router.push({path:"/mis/emailTemplate/edit",query:{label:"MIS"}});
                }
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t('mis.emailTemplate.templateName'), field: 'templateName'},
                        { title: window.$t('mis.emailTemplate.title'), field: 'title'},
                        { title: window.$t('mis.emailTemplate.enabled'), field: 'enabled',type: 2,optionList:type},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.add')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.email.templateQuery, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.emailTemplate.templateName'), field: 'templateName'},
                        { title: window.$t('mis.emailTemplate.title'), field: 'title'},
                        { title: window.$t('mis.emailTemplate.enabled'), field: 'enabled', render: (data, full) => {
                            return type[data];
                        }},
                        { title: window.$t('mis.emailTemplate.updateDate'), field: 'updateDate'},
                        {title:window.$t('mis.bt.operation'),btnClick:[{name:window.$t('mis.bt.view'),click:"view",type:"primary",icon:"el-icon-view"},{name:window.$t('mis.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},{name:window.$t('mis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"},
                                    {name:(data,full)=>{
                                        if (full.enabled == 1) return window.$t('mis.bt.disable');
                                        else return window.$t('mis.bt.enable');
                                    },click:"changeEnabled",type:"primary"}]},
                    ]
                }
            }
        }
    }
</script>
